var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-empty-page"},[_c('img',{staticClass:"photo",attrs:{"src":_vm.photo}}),_vm._v(" "),_c('div',[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78830eec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/EmptyItem.vue
// module id = null
// module chunks = 